import {useNavigate} from 'react-router'
import {useSchools} from '@freckle/educator-entities/ts/common/hooks/use-schools'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import {WithResources} from '@freckle/school/ts/common/components/with-resources'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import {useQueryParamAsNum} from '@freckle/school/ts/hooks/use-params'
import {Usage} from '@freckle/school/ts/usage/components/usage'
import {useSchoolAdmin} from '../../hooks/use-school-admin'
import type {SchoolAdminAttrs} from '../../users/models/school-admin'

export default function UsageHandler() {
  const schools = useSchools()
  const schoolAdmin = useSchoolAdmin()
  return <WithResources resources={{schools, schoolAdmin}} render={data => <Inner {...data} />} />
}

type InnerProps = {
  schools: Array<SchoolAttrs>
  schoolAdmin: SchoolAdminAttrs
}

function Inner({schools, schoolAdmin}: InnerProps) {
  const schoolId = useQueryParamAsNum('schoolId')
  const routerHistory = useNavigate()

  return (
    <Usage
      schools={schools}
      schoolAdmin={schoolAdmin}
      initSchoolId={schoolId ?? undefined}
      onChangeSchool={schoolId => routerHistory(Routes.usage(schoolId))}
      onAllSchools={() => routerHistory(Routes.usage())}
    />
  )
}
